import { useState } from 'react';
import toast from 'react-hot-toast';
import { useEndpoints } from '../../hooks/useEndpoints';
import { useConfirmModal } from '../../hooks/useConfirmModal/useConfirmModal';

/**
 * Sollecito globale (feature #17): invia in un colpo la push agli atleti con
 * attività in sospeso (questionario di oggi + eventi non compilati). Chiede
 * conferma prima (azione impattante, pattern useConfirmModal del progetto);
 * best-effort, senza anti-spam. Logica isolata dal componente (react-pulito).
 */
export const useGlobalReminder = () => {
  const { remindGlobal } = useEndpoints();
  const { handleOpen } = useConfirmModal();
  const [isSending, setIsSending] = useState(false);

  const doSend = async () => {
    setIsSending(true);
    const id = toast.loading('Invio solleciti in corso...');
    try {
      const { data } = await remindGlobal();
      // `total` = atleti in sospeso; `sent` = notifiche effettivamente inviate.
      // Distinti apposta: pending senza app installata → total>0 ma sent=0.
      if (data.total === 0) {
        toast.success('Nessun atleta da sollecitare: tutto compilato', { id });
      } else if (data.sent > 0) {
        toast.success(
          `${data.total} atleti da sollecitare · ${data.sent} notifiche inviate`,
          { id },
        );
      } else if (data.failed > 0) {
        // Device presenti ma tutte le push fallite: errore di consegna, non
        // assenza di app.
        toast(
          `${data.total} atleti in sospeso · invio notifiche non riuscito (${data.failed})`,
          { id, icon: '⚠️' },
        );
      } else {
        toast(
          `${data.total} atleti in sospeso, ma nessuno ha l'app installata`,
          { id, icon: '⚠️' },
        );
      }
    } catch {
      toast.error("Errore durante l'invio dei solleciti", { id });
    } finally {
      setIsSending(false);
    }
  };

  const send = () => {
    handleOpen({
      title: 'Sollecitare gli atleti?',
      description:
        'Invia una notifica agli atleti che non hanno compilato il questionario di oggi o hanno eventi in sospeso.',
      onConfirm: doSend,
    });
  };

  return { send, isSending };
};
